import React from "react";
import PropTypes from "prop-types";

import { ErrorIcon, InfoIcon, ProcessTickIcon } from "../../../assets";

import styles from "./index.module.css";
import { Button } from "../../formControls/Button/Button";

const renderIcon = (type) => {
  switch (type) {
    case "error":
      return <ErrorIcon width={26} height={26} className={styles.closeIcon} />;

    case "warning":
      return <InfoIcon width={20} height={20} className={styles.closeIcon} />;

    case "success":
      return <ProcessTickIcon width={20} height={20} className={styles.closeIcon} />;

    default:
      break;
  }
};

export const Snackbar = ({ type, title, content, actionBtn, handleActionBtn }) => {
  return (
    <div className={styles.notificationSection} role="alert">
      <div className={styles.notification}>
        <div>{renderIcon(type)}</div>
        <div className={styles.notificationMessage}>
          <h3 className={styles.notificationTitle}>{title}</h3>
          <div className={styles.notificationContent}>{content}</div>
        </div>
      </div>
      {actionBtn && <div className={styles.actionBtn}>
        <Button myClassName={styles.customBtn} onClick={handleActionBtn}> {actionBtn} </Button>
      </div>}
    </div>
  );
};

Snackbar.propTypes = {
  type: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  content: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};
